// extracted by mini-css-extract-plugin
export default {"wrapper":"AvailableBrowser_wrapper__+yZQl","header":"AvailableBrowser_header__9SMDx","container":"AvailableBrowser_container__VZxRG","desc":"AvailableBrowser_desc__zpPwO"};